module.exports = __webpack_public_path__ + "static/media/Aluminum Corrugated Sheet_Corten rotated.554b8bba.jpg";